import { assertValue } from '@shared/helpers'
import { IfpApplicationRequestData, IfpLoan } from '@shared/sec-loans'
import { toNumber } from '@ui-common/utils'

import { resolveValueFromFormFields } from '../../../utils/helpers'
import { isFormDataValid } from '../../../wizard/wizardData'
import { isLongWizardFlow } from '../../utils'
import { IfpWizardData } from '../../wizard/types'
import { createFormValidator } from './formValidator'
import { IfpHouseholdInfoFormData } from './types'

export const isHouseholdInfoValid = (data: IfpHouseholdInfoFormData | undefined): boolean => {
  return !!data && isFormDataValid(data, createFormValidator)
}

export const getAndValidateHouseholdInfoData = (
  data: Partial<IfpWizardData>,
  loan: IfpLoan,
): IfpApplicationRequestData['householdInfo'] | undefined => {
  const basicInfo = data.basicInfo
  const householdInfoData = data.householdInfo
  const isLongFlow = isLongWizardFlow({
    durationInMonths: toNumber(basicInfo?.durationInMonths),
    hasFinancialDifficulties: basicInfo?.hasFinancialDifficulties,
    principalExemptionMonthsLeft: loan.principalExemptionMonthsLeft,
  })

  const isValidHouseholdInfo = householdInfoData && isHouseholdInfoValid(householdInfoData)

  if (isValidHouseholdInfo && isLongFlow) {
    const numberOfChildren = resolveValueFromFormFields(
      assertValue(householdInfoData?.numberOfChildren, 'householdInfoData.numberOfChildren'),
      householdInfoData.numberOfChildrenOther,
    )
    const numberOfAdults = assertValue(householdInfoData.numberOfAdults, 'data.numberOfAdults')
    return {
      numberOfAdults: parseInt(numberOfAdults),
      numberOfChildren: assertValue(numberOfChildren, 'numberOfChildren'),
    }
  }

  return undefined
}
